<template>
  <div>
    <vs-card class="border_primary px-2">
      <div v-for="(item, index) in data" :key="index">
        <div v-if="item.isShow">
          <div v-if="item.type == 'String'">
            <div v-if="index == 'right_top_text'">
              <stringPage :stringData="item"></stringPage>
            </div>
            <div v-else>
              <p class="text-primary text-lg font-semibold">{{ item.name }}</p>

              <hr class="mt-3 mb-5" />
              <stringPage :stringData="item"></stringPage>
            </div>
          </div>
          <div v-if="item.type == 'Link'">
            <p class="text-primary text-lg font-semibold">{{ item.name }}</p>

            <hr class="mt-3 mb-5" />
            <linkPage :linkData="item"></linkPage>
          </div>
          <div v-if="item.type == 'Date'">
            <p class="text-primary text-lg font-semibold">{{ item.name }}</p>

            <hr class="mt-3 mb-5" />
            <datePage :dateData="item"></datePage>
          </div>
          <div v-if="item.type == 'Number'">
            <p class="text-primary text-lg font-semibold">{{ item.name }}</p>

            <hr class="mt-3 mb-5" />
            <numberPage :numberData="item"></numberPage>
          </div>
          <div v-if="item.type == 'Image'">
            <p class="text-primary text-lg font-semibold">{{ item.name }}</p>

            <hr class="mt-3 mb-5" />

            <imagePage :imageData="item" />
          </div>
          <div v-if="item.type == 'Video'">
            <p class="text-primary text-lg font-semibold py-2">
              {{ item.name }}
            </p>

            <hr class="mt-3 mb-5" />

            <videoPage :videoPage="item" />
          </div>
          <div v-if="item.type == 'Object'">
            <p class="text-primary text-lg font-semibold py-2">
              {{ item.name }}
            </p>

            <hr class="mt-3 mb-5" />
            <objectPage :objectData="item" />
          </div>
          <div v-if="item.type == 'Array'">
            <p class="text-primary text-lg font-semibold py-2">
              {{ item.name }}
            </p>

            <hr class="mt-3 mb-5" />
            <arrayPage :arrayData="item" />
          </div>
          <div v-if="item.type == 'ArrayObject'">
            <p class="text-primary text-lg font-semibold py-2">
              {{ item.name }}
            </p>

            <hr class="mt-3 mb-5" />
            <!-- {{ item }} -->
            <arrayObjectPage :arrayObjectData="item" />
            <!-- <arrayObjectPage :arrayObjectData="item" /> -->
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>
<script>
import Media from "@dongido/vue-viaudio";
import stringPage from "./../pageComponent/stringPage/stringPage";
import imagePage from "./../pageComponent/imagePage/imagePage";
import videoPage from "./../pageComponent/videoPage/videoPage";
import objectPage from "./../pageComponent/objectPage/objectPage";
import arrayPage from "./../pageComponent/arrayPage/arrayPage";
import arrayObjectPage from "./../pageComponent/arrayObjectPage/arrayObjectPage";
import linkPage from "./../pageComponent/linkPage/linkPage";
import datePage from "./../pageComponent/datePage/datePage";
import numberPage from "./../pageComponent/numberPage/numberPage";
import { mapGetters } from "vuex";
import { setTimeout } from "timers";
export default {
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch("general/getTab", "board");
    // this.$store.dispatch("second/getDataCompCardContent");
  },
  methods: {
    handle() {
      console.log("Video paused!, playing in 2 sec...");

      setTimeout(() => {
        this.$refs.video_player.play();
      }, 2000);
    }
  },
  components: {
    Media,
    stringPage,
    imagePage,
    videoPage,
    objectPage,
    arrayPage,
    arrayObjectPage,
    linkPage,
    datePage,
    numberPage
  },
  computed: {
    ...mapGetters({
      data: "general/detailData",
      nowSlug: "getNowSlug",
      tabActive: "general/tabActive",
       id_user:"general/id_user"
    })
  },
  watch: {
    tabActive(newValue, oldValue) {
      console.log(oldValue.path);
      console.log("value tab comp", this.nowSlug, newValue.path);

      if (newValue.path == "progress") {
        console.log("aa active");
        this.$store.dispatch("general/getRenderDetail", {
          path: this.nowSlug,
          detail: newValue.path,
          id_user:this.id_user

        });
      } else if (oldValue.path == "progress") {
        this.$store.dispatch("general/getRenderDetail", {
          path: this.nowSlug,
          detail: newValue.path,
          id_user: this.id_user
        });
      }
    }
  }
};
</script>
<style lang="scss">
.photo_act {
  width: 100px;
  height: 135px;
  border: solid 1px rgba(var(--vs-dark), 1);
}
</style>
